import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { watchnetworthGrowthSaga } from './saga';
import { NetworthGrowthState } from './types';

export const initialState: NetworthGrowthState = {
  isLoading: false,
  data: null,
};

const slice = createSlice({
  name: 'networthGrowth',
  initialState,
  reducers: {
    networthGrowth(state, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    networthGrowthSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.data = action.payload;
    },
    networthGrowthFail(state, action: PayloadAction<any>) {
      state.isLoading = false;
    },
  },
});

export const { actions: networthGrowthActions } = slice;

export const useNetworthGrowthSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: watchnetworthGrowthSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useNetworthGrowthSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
